/**
 * Authentication Routes
 * Imported from auth domain
 */
import authRoutes from '../domain/auth/routes'

export default authRoutes

